export const PrivacyIcon = require("../../../assets/images/icon-privacy.png");
export const TermsIcon = require("../../../assets/images/icon-terms.png");
